import { parse, print } from 'graphql'

export const operationTemplates = [
  {
    id: 'dailyCalculators',
    label: 'คำนวนดอกเบี้ยรายวัน',
    description:
      'คำนวณดอกเบี้ยรายวันสำหรับสัญญาที่เข้าเงื่อนไขเดียวกับ cron โดยมีการบันทึกข้อมูลจริง ใช้ตัวแปร {} และต้องพิมพ์ RUN_DAILY_CALCULATORS เพื่อยืนยันก่อนเริ่ม ปิดหน้าเว็บไม่ได้ยกเลิกงาน หากการเชื่อมต่อขัดข้องให้ตรวจสอบผลก่อนเรียกซ้ำ',
    command: `mutation DailyCalculators {
  dailyCalculators {
    id
    contractNo
    contractName
  }
}`,
    variables: '{}',
  },
  {
    id: 'clearDatabaseLogs',
    label: 'ล้างประวัติระบบ',
    description:
      'ล้างประวัติที่เกินระยะเวลาเก็บของระบบ เริ่มด้วย dryRun: true เพื่อตรวจสอบจำนวนโดยไม่ลบข้อมูล เปลี่ยนเป็น false เพื่อเข้าสู่ขั้นตอนยืนยันลบ โดยคง confirmation เป็น null และพิมพ์ CLEAR_DATABASE_LOGS ในหน้าต่างยืนยัน การลบกู้คืนไม่ได้หากไม่มีข้อมูลสำรอง ปิดหน้าเว็บไม่ได้ยกเลิกงาน',
    command: `mutation ClearDatabaseLogs($dryRun: Boolean!, $confirmation: String) {
  clearDatabaseLogs(dryRun: $dryRun, confirmation: $confirmation) {
    dryRun
    startedAt
    completed
    results {
      name
      enabled
      months
      days
      cutoff
      eligible
      deleted
      detailEligible
      detailDeleted
      skipped
      errorCode
    }
  }
}`,
    variables: '{\n  "dryRun": true,\n  "confirmation": null\n}',
  },
  {
    id: 'getPendingDailyCalculations',
    label: 'ตรวจสอบสัญญาที่ยังไม่ได้คำนวณดอกเบี้ยรายวัน',
    description:
      'ตรวจสัญญาที่เข้าเงื่อนไข cron และยังไม่มีรายการดอกเบี้ยของเมื่อวาน (targetDate) โดยไม่สั่งคำนวณหรือแก้ยอดเงิน ค่าเริ่มต้น sendEmail: false ไม่ส่งเมล เปลี่ยนเป็น true เพื่อส่งรายการค้างทั้งหมดไปยังผู้รับเดิม แม้ไม่มีรายการค้างก็ส่งเมลแจ้ง เปลี่ยน page เพื่อดูหน้าถัดไป และกำหนด pageSize ได้ 1–100 รายการ lastCalculationDate เป็น null หมายถึงยังไม่พบรายการดอกเบี้ย emailStatus: SENT หมายถึง SMTP รับอีเมลแล้ว, DISABLED คือปิดส่งใน environment นี้, NOT_REQUESTED คือไม่ได้ขอส่ง ผลตรวจไม่ใช่การยืนยันว่างานคำนวณทุกขั้นตอนเสร็จสมบูรณ์',
    command: `mutation GetPendingDailyCalculations($page: Int!, $pageSize: Int!, $sendEmail: Boolean = false) {
  getPendingDailyCalculations(page: $page, pageSize: $pageSize, sendEmail: $sendEmail) {
    targetDate
    page
    pageSize
    total
    emailStatus
    items {
      id
      contractNo
      contractName
      lastCalculationDate
    }
  }
}`,
    variables: '{\n  "page": 1,\n  "pageSize": 50,\n  "sendEmail": false\n}',
  },
]

// UI scope only. Backend authorizes both queries and mutations.
export function prepareOperation(templateId, command, variablesText) {
  const template = operationTemplates.find((item) => item.id === templateId)
  if (!template) throw new Error('กรุณาเลือกเทมเพลตคำสั่ง')
  let document
  let variables
  try {
    document = parse(command)
  } catch (_) {
    throw new Error('รูปแบบคำสั่ง GraphQL ไม่ถูกต้อง')
  }
  try {
    variables = JSON.parse(variablesText)
  } catch (_) {
    throw new Error('ตัวแปรต้องเป็น JSON ที่ถูกต้อง')
  }
  if (!variables || Array.isArray(variables) || typeof variables !== 'object')
    throw new Error('ตัวแปรต้องเป็น JSON object')
  const operation = document.definitions[0]
  const expected = parse(template.command).definitions[0]
  if (
    document.definitions.length !== 1 ||
    operation.kind !== 'OperationDefinition' ||
    operation.operation !== expected.operation ||
    operation.directives.length ||
    operation.selectionSet.selections.length !== 1
  )
    throw new Error(
      'หน้านี้รองรับ operation เดียวตามประเภทของเทมเพลตที่เลือกเท่านั้น'
    )
  const field = operation.selectionSet.selections[0]
  if (
    field.kind !== 'Field' ||
    field.name.value !== templateId ||
    field.alias ||
    field.directives.length ||
    field.arguments.map(print).join() !==
      expected.selectionSet.selections[0].arguments.map(print).join() ||
    operation.variableDefinitions.map(print).join() !==
      expected.variableDefinitions.map(print).join()
  )
    throw new Error(
      'กรุณาคงชื่อ operation และตัวแปรตามเทมเพลต ปรับได้เฉพาะ fields ผลลัพธ์'
    )
  if (templateId === 'dailyCalculators' && Object.keys(variables).length)
    throw new Error('คำนวณดอกเบี้ยรายวันไม่รับตัวแปร ใช้ {}')
  if (templateId === 'clearDatabaseLogs') {
    if (
      Object.keys(variables).some(
        (key) => !['dryRun', 'confirmation'].includes(key)
      ) ||
      typeof variables.dryRun !== 'boolean' ||
      (variables.confirmation !== undefined &&
        variables.confirmation !== null &&
        variables.confirmation !== '')
    )
      throw new Error(
        'กำหนด dryRun เป็น true/false และ confirmation เป็น null; ยืนยันการลบผ่านหน้าต่างยืนยันเท่านั้น'
      )
  }
  if (
    templateId === 'getPendingDailyCalculations' &&
    (Object.keys(variables).some(
      (key) => !['page', 'pageSize', 'sendEmail'].includes(key)
    ) ||
      (variables.sendEmail !== undefined &&
        typeof variables.sendEmail !== 'boolean') ||
      !Number.isInteger(variables.page) ||
      variables.page < 1 ||
      variables.page > 100000 ||
      !Number.isInteger(variables.pageSize) ||
      variables.pageSize < 1 ||
      variables.pageSize > 100)
  )
    throw new Error('กำหนด page ระหว่าง 1–100000 และ pageSize ระหว่าง 1–100')
  return { document, variables, templateId, operation: operation.operation }
}
